function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgDirectionSigns = function SvgDirectionSigns(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Direction Signs' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 25 25"
  }), React.createElement("path", {
    d: "M23 14.953l-3.386-3.255h-6.138v-1.86h5.714V3.325h-5.714V1h-.952v2.326H6.386L3 6.58l3.386 3.256h6.138v1.86H6.81v6.512h5.714v5.117h.952v-5.117h6.138L23 14.953zM4.405 6.581l2.352-2.325h11.481v4.651H6.758L4.404 6.581zM7.762 17.28v-4.651h11.48l2.353 2.325-2.352 2.326H7.762z"
  }));
};

SvgDirectionSigns = pure(SvgDirectionSigns);
SvgDirectionSigns.displayName = 'SvgDirectionSigns';
export default SvgDirectionSigns;